import React from 'react';

import { AppBar, Tab, Tabs } from '@material-ui/core';
import LeftArrow from '@material-ui/icons/ChevronLeftRounded';
import Button from '../../../../components/Button';

export interface ITabStep {
  content: JSX.Element;
  label: string;
}

interface IAdminTabsNav {
  steps: ITabStep[];
  activeTab: any;
  setTab: any;
  backButtonText?: string;
  backButtonOnClick?: any;
}

export const AdminTabsNav = (props: IAdminTabsNav) => {
  const { activeTab, setTab, steps, backButtonText, backButtonOnClick } = props;

  return (
    <div className="admin-tabs-nav-wrapper">
      {backButtonOnClick && (
        <div className="back-button-container">
          <div className="admin-wrapper">
            <Button
              color="primary"
              onClick={backButtonOnClick}
              className="all-events-button override"
              variant="text"
            >
              <LeftArrow className="left-arrow-icon" />
              {backButtonText || 'BACK'}
            </Button>
          </div>
        </div>
      )}

      <AppBar className="club-settings-tab-menu" position="static">
        <Tabs
          value={activeTab}
          onChange={setTab}
          variant="standard"
          centered={true}
          classes={{
            indicator: 'tab-indicator'
          }}
        >
          {steps.map(({ label }, index) => (
            <Tab
              label={label}
              key={`club-settings-tab-${index}`}
              className="admin-tab"
              classes={{ wrapper: 'tab-label' }}
            />
          ))}
        </Tabs>
      </AppBar>
    </div>
  );
};
